import styled from "@yb/styled-px2rem";
import {InputSProps} from "@FRAMEWORK/ui/types/d";
import {forwardRef} from "react";

interface Props extends InputSProps {
	width?: string;
}

const Input = styled.input<Props>`
	width: ${props => props.width || "100%"};
	padding: 10px;

	&:read-only {
		cursor: auto;
	}

	border-color: ${props => props.required === true && "var(--red-color)"};
`;

const TextInput = forwardRef<HTMLInputElement, Props>(({width, ...props}: Props, ref) => (
	<Input type="text" width={width} {...props} ref={ref} />
));

export default TextInput;
